import firebase from 'firebase'
import React from 'react'
import Avatar from '../Avatar'
import { connect } from 'react-redux'
import Separator from '../Separator'
import styled from 'styled-components'
import ReplyItem from './ReplyItem'
import * as R from 'ramda'
import {
  UserName,
  Datetime,
  Text,
  Respond,
  TextEdit,
  IconContainer,
  CommentTextSm,
  CommentTextXs,
  Cancel,
  Confirm,
  ConfirmXs,
  CancelXs,
  CommentEdit
} from './styles'
import Icon from '../Icon'
import Button from '../Button'
import { dispatch } from '../../store'
import { getDuration } from 'src/utils'
import { Flex, Box } from '@rebass/grid'

const Container = styled.div`
  background-color: #f7f8f8;
  padding: 24px 20px;
  margin: 12px auto;
`

class DiscussionBlock extends React.Component {
  state = {
    responding: false,
    comment: '',
    editing: false,
    discussionText: this.props.discussion.text
  }

  render() {
    const currentUser = firebase.auth().currentUser
    const { users, discussion, isAuthenticated } = this.props
    const author = users[discussion.authorId]
      ? users[discussion.authorId]
      : null
    const { responding, comment, editing } = this.state

    return (
      <Container>
        <Flex flexDirection="column">
          <Flex mb={4}>
            <Box width={44} mr={3}>
              <Avatar userId={discussion.authorId} fluid={true} />
            </Box>
            <Flex flex={1} flexDirection="column">
              <Flex justifyContent="space-between" mb={1}>
                <UserName>{author ? author.fullName : '講者'}</UserName>
                <Datetime>
                  {discussion.ts ? getDuration(discussion.ts) : null}
                </Datetime>
              </Flex>
              <Box>
                {!editing ? (
                  <Flex justifyContent="space-between">
                    <Box>
                      <Text>{discussion.text}</Text>
                    </Box>
                    {currentUser && discussion.authorId === currentUser.uid ? (
                      <Box width={30} ml={4}>
                        <Icon width={16} height={16}
                          type="edit"
                          onClick={() => this.setState({ editing: true })}
                        />
                      </Box>
                    ) : null}
                  </Flex>
                ) : (
                    <Box py={1}>
                      <CommentTextXs
                        autoFocus={true}
                        value={this.state.discussionText}
                        onChange={e =>
                          this.setState({ discussionText: e.target.value })
                        }
                      // onBlur={() => this.setState({ editing: false })}
                      />
                      <CancelXs
                        onClick={() => {
                          this.setState({
                            editing: false,
                            discussionText: discussion.text
                          })
                        }}
                      >
                        取消
                    </CancelXs>
                      <ConfirmXs
                        onClick={() => {
                          dispatch.lectureDiscussion
                            .updateDiscussion({
                              discussionId: discussion.id,
                              text: this.state.discussionText
                            })
                            .then(_ => this.setState({ editing: false }))
                        }}
                      >
                        確定
                    </ConfirmXs>
                    </Box>
                  )}
              </Box>
            </Flex>
          </Flex>
          <Box>{discussion.replies.length ? <Separator /> : null}</Box>
          <Flex pl={56} flexDirection="column">
            {R.sortBy(reply => reply.ts)(discussion.replies).map(reply => (
              <Box pb={16} key={reply.id}>
                <ReplyItem discussion={discussion} reply={reply} />
              </Box>
            ))}
            {isAuthenticated ? (
              !responding ? (
                <Box>
                  <Respond onClick={() => this.setState({ responding: true })}>
                    回覆
                  </Respond>
                </Box>
              ) : (
                  <React.Fragment>
                    <Box mb={3}>
                      <CommentTextSm
                        autoFocus={true}
                        className="col-10"
                        value={comment}
                        placeholder="在這邊輸入任何你想跟講師討論的想法吧！"
                        onChange={e => this.setState({ comment: e.target.value })}
                      />
                    </Box>
                    <Flex justifyContent="flex-end">
                      <Box mr={3}>
                        <Button
                          intent="primary"
                          line={true}
                          onClick={() => this.setState({ responding: false })}
                        >
                          取消
                      </Button>
                      </Box>
                      <Box>
                        <Button
                          intent="primary"
                          disabled={!comment}
                          onClick={() => {
                            dispatch.lectureDiscussion
                              .replyDiscussion({
                                discussionId: discussion.id,
                                text: comment
                              })
                              .then(_ => this.setState({ comment: '' }))
                          }}
                        >
                          留言
                      </Button>
                      </Box>
                    </Flex>
                  </React.Fragment>
                )
            ) : null}
          </Flex>
        </Flex>
      </Container>
    )
  }
}

const mapState = ({ users, auth }) => ({
  users,
  isAuthenticated: auth.isAuthenticated
})

export default connect(mapState)(DiscussionBlock)



// WEBPACK FOOTER //
// ./src/components/LectureComment/DiscussionBlock.js